import { Component, inject, signal, viewChild } from '@angular/core';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { FieldValueReplacementService } from './field-value-replacement.service';
import { FieldValueReplacementsClientSelectorComponent } from './field-value-replacements-client-selector/field-value-replacements-client-selector.component';
import { FieldValueReplacementDetailsComponent } from './field-value-replacement-details/field-value-replacement-details.component';

import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-field-value-replacements',
    templateUrl: './field-value-replacements.component.html',
    styleUrls: ['./field-value-replacements.component.scss'],
    imports: [TitleBarComponent, FieldValueReplacementsClientSelectorComponent, FieldValueReplacementDetailsComponent]
})
export class FieldValueReplacementsComponent {
  private readonly fieldValueReplacementService = inject(FieldValueReplacementService);

  private readonly clientSelector = viewChild.required<FieldValueReplacementsClientSelectorComponent>(FieldValueReplacementsClientSelectorComponent);

  public readonly selectedGridClient = signal<ClientDTO | null>(null);

  public get clientsHavingReplacements(): ClientDTO[] {
    return this.fieldValueReplacementService.clientsHavingReplacements;
  }

  public onClientSelected(client: ClientDTO) {
    this.selectedGridClient.set(client);
  }

  public onClientReplacementsDeleted() {
    this.selectedGridClient.set(null);
    this.clientSelector().reset();
  }
}
